"use client";

 
import { chakra, Button as ChakraButton } from "@chakra-ui/react";
import { buttonRecipe } from "./button.recipe";

const Button = chakra(ChakraButton, buttonRecipe);

export default Button;
